import {
    ensureObject,
    ensureString,
} from "../utils/convert-fields"

import {
    mapCadastroTemporarioResponseToState,
} from "./map-temporary-cadastro"

const ensureOCRObject = (value) => {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
        return {}
    }

    return value
}

const normalizePage = (page) => {
    if (page === null || page === undefined) return "-"

    const text = `${page}`.trim()

    if (!text || text.toLowerCase() === "null") return "-"

    return text
}

const normalizeOCRValue = (value) => {
    const text = ensureString(value).trim()

    if (!text || text.toLowerCase() === "null") return ""

    return text
}

const hasOCRValue = (value) => {
    return normalizeOCRValue(value) !== ""
}

const pickFilledFields = (state = {}) => {
    return Object.entries(state).reduce((acc, [key, value]) => {
        if (!hasOCRValue(value)) return acc

        acc[key] = value

        return acc
    }, {})
}

const cadastroOCRPageMap = {
    DataReferencia: "dataReferencia",
    DataDocumento: "dataDocumento",
    ISIN: "isin",
    NumeroSerie: "numeroSerie",
    NumeroEmissao: "numeroEmissao",
    TipoAtivo: "tipoAtivo",
    TipoOferta: "tipoOferta",
    SiteFiduciario: "siteFiduciario",
    FrequenciaJuros: "frequenciaJuros",
    FrequenciaAmortizacao: "frequenciaAmortizacao",
    ResgateAntecipado: "resgateAntecipado",
    DataEmissao: "dataEmissao",
    DataPrimeiraIntegralizacao: "dataIntegralizacao",
    DataCarenciaResgate: "dataCarencia",
    DataVencimento: "dataVencimento",
    DataResgateAntecipado: "dataResgateAntecipado",
    DataVencimentoAntecipado: "dataVencimentoAntecipado",
    Indexador: "indexador",
    Remuneracao: "remuneracao",
    PUEmissao: "puEmissao",
    SpreadEmissao: "spreadEmissao",
    PrazoMedioEmissao: "prazoMedio",
    PrazoEmissao: "prazoEmissao",
    QtdEmitida: "qtdEmitida",
    ValorSerie: "valorSerie",
    ValorTotalEmissao: "valorTotalEmissao",
    CotaSubordinacao: "cotaSubordinacao",
    CascataPagamento: "cascataPagamento",
    LiquidezDiaria: "liquidezDiaria",
    Conversibilidade: "conversibilidade",
    Incentivada: "incentivada",
    Green: "green",
    Lei12431: "lei12431",
    Lei14801: "lei14801",
    PrePagamento: "prePagamento",
    GarantiasReais: "garantiasReais",
    GarantiasFidejussorias: "garantiasFidejussorias",
    MitigadorRiscoCredito: "mitigadorRisco",
    Covenants: "covenants",
    RepactuacaoCredito: "repactuacaoCredito",
    CPFCNPJ_AgenciaRating: "agenciaRating",
    CPFCNPJ_Auditoria: "auditoria",
    CPFCNPJ_IFContaRecebedora: "contaRecebedora",
    CPFCNPJ_Registrador: "registrador",
    CPFCNPJ_Depositario: "depositario",
    CPFCNPJ_Custodiante: "custodiante",
    CPFCNPJ_Emissor: "emissor",
    CPFCNPJ_Escriturador: "escriturador",
    CPFCNPJ_Cedente: "cedente",
    CPFCNPJ_AgenteFiduciario: "agenteFiduciario",
    CPFCNPJ_Devedor: "devedor",
    ResumoDevedor: "resumoDevedor",
    Setor: "setorDevedor",
    Subsetor: "subSetorDevedor",
    DestinacaoRecursos: "destinacaoRecursos",
    Coobrigacao: "cobrigacao",

    Distribuicao: "distribuicao",
    LinkSRE: "linkSre",
    SituacaoDistribuicao: "situacaoDistribuicao",
    SituacaoOferta: "situacaoOferta",
    TipoMercado: "tipoMercado",
    TipoRito: "tipoRito",
    Bookbuilding: "bookbuilding",
    RemuneracaoBookbuilding: "remuneracaoBookbuilding",
    RegimeDistribuicao: "regimeDistribuicao",
    PublicoAlvoInvestidorGeralInicial: "investidorGeralInicial",
    PublicoAlvoInvestidorQualificadoInicial: "investidorQualificadoInicial",
    PublicoAlvoInvestidorProfissionalInicial: "investidorProfissionalInicial",
    PublicoAlvoInvestidorGeralFinal: "investidorGeralFinal",
    PublicoAlvoInvestidorQualificadoFinal: "investidorQualificadoFinal",
    PublicoAlvoInvestidorProfissionalFinal: "investidorProfissionalFinal",
    DataRequerimento: "dataRequerimento",
    DataRegistro: "dataRegistro",
    DataInicioOferta: "dataInicioOferta",
    DataEncerramentodaOfertaMaximo: "dataEncerramentoMax",
    DataEncerramentodaOfertaEfetivo: "dataEncerramentoEfetivo",
    DataInicioReserva: "dataInicioReserva",
    DatasEncerramentoReserva: "dataEncerramentoReserva",
    DataBookbuilding: "dataBookbuilding",
    DataLockupIGparaIG: "dataLockupIGparaIG",
    DataLockupIGparaIQ: "dataLockupIGparaIQ",
    DataLockupIGparaIP: "dataLockupIGparaIP",
    DataLockupIQparaIG: "dataLockupIQparaIG",
    DataLockupIQparaIQ: "dataLockupIQparaIQ",
    DataLockupIQparaIP: "dataLockupIQparaIP",
    DataLockupIPparaIG: "dataLockupIPparaIG",
    DataLockupIPparaIQ: "dataLockupIPparaIQ",
    DataLockupIPparaIP: "dataLockupIPparaIP",
    CPFCNPJ_CoordenadorLider: "coordLider",
    CPFCNPJ_Coordenador1: "coord1",
    CPFCNPJ_Coordenador2: "coord2",
    CPFCNPJ_Coordenador3: "coord3",
    CPFCNPJ_Coordenador4: "coord4",
    CPFCNPJ_Coordenador5: "coord5",
    CPFCNPJ_Coordenador6: "coord6",
    CPFCNPJ_Coordenador7: "coord7",

    TipoLastro: "tipoLastro",
    ContaVinculada: "contaVinculada",
    CotasInferiores: "cotasInferiores",
    AlienacaoFiduciaria: "alienacao",
    CessaoFiduciaria: "cessao",
    FiancaBancaria: "fiancaBancaria",
    Hipoteca: "hipoteca",
    Penhor: "penhor",
    Avalista: "avalista",
    Fianca: "fianca",
    FundoObra: "fundoObra",
    FundoReserva: "fundoReserva",
    FundoLiquidez: "fundoLiquidez",
    Seguro: "seguro",
    Sobregarantia: "sobreGarantia",
    PatrimonioSeparado: "patrimonioSeparado",

    LTVNumerador: "ltvNumerador",
    LTVDenominador: "ltvDenominador",
    LTV: "ltv",
}

export const mapCadastroOCRResponseToState = (data = {}) => {
    const resultado = ensureObject(data.Resultado)

    const valoresOCR = {}

    Object.entries(resultado).forEach(([campo, info]) => {
        const valor = normalizeOCRValue(info?.valor)

        if (!valor) return

        valoresOCR[campo] = valor
    })

    const mapped = mapCadastroTemporarioResponseToState({
        ID: data.ID,
        CETIP: data.CETIP,
        VersaoDocumento: data.VersaoDocumento,
        Caracteristica: valoresOCR,
        Oferta: valoresOCR,
        Garantias: valoresOCR,
        LTV: valoresOCR,
    })

    const caracteristicasState = pickFilledFields(mapped.caracteristicasState)

    if (!valoresOCR.DataCarenciaResgate) {
        delete caracteristicasState.dataCarenciaManual
    }

    if (!valoresOCR.DataPrimeiraIntegralizacao) {
        delete caracteristicasState.dataIntegralizacaoManual
    }

    return {
        ...mapped,
        caracteristicasState,
        ofertaState: pickFilledFields(mapped.ofertaState),
        garantiasState: pickFilledFields(mapped.garantiasState),
    }
}

export const mapCadastroOCRPagesToState = (data = {}) => {
    const resultado = ensureOCRObject(data.Resultado)

    return Object.entries(resultado).reduce((acc, [campo, info]) => {
        const stateKey = cadastroOCRPageMap[campo]

        if (!stateKey) return acc

        acc[stateKey] = {
            page: normalizePage(info?.page),
        }

        return acc
    }, {})
}